<template>
    <ContentCard theme="darkgreen" icon="assets/images/illu-claw.svg" class="w-70">
        <template #title>Behind the scenes: Australovenator</template>
        <template #description>
            Go behind the scenes of the Erth dinosaur puppet workshop and learn about the amazing Australian  Australovenator dinosaur.
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'XnUaYg5ONpg')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/fossil-drop.pdf" target="_blank" icon="file" class="card__btn" orange>
                ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
